import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuthModal } from '../contexts/AuthModalContext';

/**
 * Fallback login page - opens the auth modal and redirects to home if closed
 * This route is kept for compatibility but should not be used directly in normal flow
 */
export default function LoginPage() {
  const { isAuthenticated } = useAuth();
  const { openAuthModal, isOpen, closeAuthModal } = useAuthModal();
  const navigate = useNavigate();
  const location = useLocation();

  // Open modal on mount if not authenticated
  useEffect(() => {
    if (!isAuthenticated && !isOpen) {
      openAuthModal({ reason: 'login-page', fromPath: location.pathname });
    }
  }, [isAuthenticated, isOpen, location.pathname, openAuthModal]);

  // Redirect to home if authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // If modal closes and user is still not authenticated, go to home
  useEffect(() => {
    if (!isAuthenticated && !isOpen) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isOpen, navigate]);

  // Show minimal UI behind the modal
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-white mb-4">Sign In</h1>
        <p className="text-white/70 mb-6">
          Please sign in to continue.
        </p>
        <button
          onClick={() => {
            closeAuthModal();
            navigate('/', { replace: true });
          }}
          className="text-white/60 hover:text-white transition-colors text-sm underline"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}
